import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Check, Crown, Skull } from "lucide-react";
import { toast } from "sonner";

const PERKS = [
  "Unlimited full-length listening",
  "No 25-second cutoffs, ever",
  "Every album, every exclusive drop",
  "Offline-ready PWA install",
  "Support the underground directly",
];

export default function Subscribe() {
  const { isPremium, user } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        origin_url: window.location.origin,
        user_id: user?.id,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("Could not start checkout. Try again.");
      setLoading(false);
    }
  };

  return (
    <div className="px-6 md:px-12 py-12 max-w-4xl">
      <div className="overline text-xs text-accent mb-3 flex items-center gap-2"><Skull size={14} /> Premium Membership</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[0.95] mb-4">
        UNLOCK THE<br /><span className="text-primary">FULL SOUND.</span>
      </h1>
      <p className="text-muted-foreground max-w-lg mb-10">
        Guests only hear 25 seconds. Members hear everything. Cancel anytime.
      </p>

      <div className="bg-card border-2 border-primary p-8 md:p-10 block-shadow max-w-md">
        <div className="flex items-baseline gap-2 mb-1">
          <span className="font-display text-6xl font-bold">$5</span>
          <span className="text-muted-foreground overline text-sm">/ month</span>
        </div>
        <div className="overline text-xs text-accent mb-6">Premium Access</div>
        <ul className="space-y-3 mb-8">
          {PERKS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm">
              <Check size={18} className="text-primary shrink-0 mt-0.5" /> {p}
            </li>
          ))}
        </ul>
        {isPremium ? (
          <div data-testid="already-premium" className="border-2 border-accent text-accent overline text-sm font-bold text-center py-4 flex items-center justify-center gap-2">
            <Crown size={18} /> You're Premium
          </div>
        ) : (
          <Button data-testid="subscribe-btn" onClick={checkout} disabled={loading} className="w-full h-14 bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline text-base">
            {loading ? "Redirecting..." : "Subscribe · $5/mo"}
          </Button>
        )}
        <p className="text-[11px] text-muted-foreground mt-4 text-center">Secure checkout via Stripe. Test card 4242 4242 4242 4242.</p>
      </div>
    </div>
  );
}
